<template>
  <section class="section">
    <div class="container">
      <h1 class="page_header page_header hide_mobile">Earn with Upskill</h1>
      <div class="signup_wrapper">
        <div class="signup" v-for="(item, index) in items" :key="index" @click="Goto(item.goto)">
          <img class="img-fluid" :src="item.image" alt="Sign Up" />
          <h2 class="signup__text" v-html="item.title"></h2>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["items"],
  created() {
    // console.log(this.items);
  }
};
</script>

<style scoped>
.signup:hover {
  cursor: pointer;
  opacity: 0.8;
}
</style>
